export default function (validationCollection) {
    return validationCollection.every((singleValidationResult) => {
        if (typeof singleValidationResult !== 'object') {
            return singleValidationResult;
        }
        return singleValidationResult.every(singleValidationTest => singleValidationTest.testValue);
    });
}
